<template>
<div class="chapter">
<div class="inner_page">
<p class="sp1"> </p>
<p class="FMH"><a id="pg_vii">Contents</a></p><a id="pg_vii">
</a><p class="CFMH"><a id="pg_vii"></a><a href="#/xhtml/acknowledgments#ack"><span class="ePub-I">Acknowledgments</span></a></p>
<p class="CFMH__1"><a href="#/xhtml/prologue#pro">Prologue: Condorcet’s Dream</a></p>
<div class="cpt-top">
<p class="CPT">          <a href="#/xhtml/part1#part1"><span class="SC-B">PART I. THE ARTICLES OF THE CONSTITUTION</span></a></p>
<p class="CCT"><a href="#/xhtml/chapter1#ch1"><span class="ccn">1.21.</span>   Stand Up and Be Estimated</a></p>
<p class="CCT"><a href="#/xhtml/chapter2#ch2"><span class="ccn">1.22.</span>   (Nearly) Equal Representation</a></p>
<p class="CCT"><span href="#/xhtml/chapter3#ch3" title="Link target outside of Sample"><span class="ccn">1.23.</span>   Weighting for a Fair Vote</span></p>
<p class="CCT"><span href="#/xhtml/chapter4#ch4" title="Link target outside of Sample"><span class="ccn">1.24.</span>   The Impossibility of Democracy</span></p>
<p class="CCT"><span href="#/xhtml/chapter5#ch5" title="Link target outside of Sample"><span class="ccn">1.4.</span>     Dragons and Dummymanders</span></p>
<p class="CCT"><span href="#/xhtml/chapter6#ch6" title="Link target outside of Sample"><span class="ccn">2.1.</span>     The Worst Way to Elect a President, Except for All the Rest</span></p>
<div class="cpt-top">
<p class="CPT">          <span href="#/xhtml/part2#part2" title="Link target outside of Sample"><span class="SC-B">PART II. THE BILL OF RIGHTS</span></span></p>
<p class="CCT"><span href="#/xhtml/chapter7#ch7" title="Link target outside of Sample"><span class="ccn">A4.1.</span>  Stop and Frisk</span></p>
<p class="CCT"><span href="#/xhtml/chapter8#ch8" title="Link target outside of Sample"><span class="ccn">A4.2.</span>  Reverend Thomas Bayes and the Law</span></p>
<p class="CCT"><span href="#/xhtml/chapter9#ch9" title="Link target outside of Sample"><span class="ccn">A5.</span>     “The Man of Statistics”</span></p>
<p class="CCT"><span href="#/xhtml/chapter10#ch10" title="Link target outside of Sample"><span class="ccn">A6.1.</span>  Despair over Disparity</span></p>
<p class="CCT"><span href="#/xhtml/chapter11#ch11" title="Link target outside of Sample"><span class="ccn">A6.2.</span>  Once Is an Accident …</span></p>
<p class="CCT"><span href="#/xhtml/chapter12#ch12" title="Link target outside of Sample"><span class="ccn">A6.3.</span>  <span class="ePub-STRK">12</span> <span class="ePub-STRK">6</span> <span class="ePub-STRK">5</span> <span class="ePub-STRK">10</span> <span class="ePub-I">n-</span>Angry Men</span></p>
<p class="CCT"><span href="#/xhtml/chapter13#ch13" title="Link target outside of Sample"><span class="ccn">A8.1.</span>  The Peril and Promise of Social Network Analysis</span></p>
<p class="CCT"><span href="#/xhtml/chapter14#ch14" title="Link target outside of Sample"><span class="ccn">A8.2.</span>  Three Strikes for Three Strikes</span></p>
<p class="CCTL"><span href="#/xhtml/chapter15#ch15" title="Link target outside of Sample"><span class="ccn">A8.3.</span>  The Price of Punishment</span></p>
<p class="CBMH__1"><span href="#/xhtml/epilogue#epi" title="Link target outside of Sample">Epilogue: The Constitutional Equation</span></p>
<p class="CBMH"><span href="#/xhtml/bibliography#bib" title="Link target outside of Sample"><span class="ePub-I">Select Topical Bibliography</span></span></p>
<p class="CBMH"><span href="#/xhtml/index#index" title="Link target outside of Sample"><span class="ePub-I">Index</span></span></p>
</div></div>
</div>
</div>
</template>
<script>

export default {
  name: 'chapter',
  data() {
    return {}
    },
      components: {
    }
  }
</script>



// WEBPACK FOOTER //
// contents.vue?4e5a8b35